import { FiLayout, FiServer, FiCloud, FiShield } from "react-icons/fi";
import SectionHeading from "../../components/SectionHeading";
import SectionArt from "../../components/SectionArt";
import Reveal from "../../components/Reveal";
import TiltCard from "../../components/TiltCard";

const groups = [
  {
    title: "Frontend",
    icon: FiLayout,
    accent: "from-aurora-cyan to-aurora-indigo",
    text: "text-content",
    skills: [
      "React", "Next.js", "Angular", "Vue.js", "Nuxt.js",
      "TypeScript", "JavaScript", "Tailwind", "SCSS",
    ],
  },
  {
    title: "Backend & Mobile",
    icon: FiServer,
    accent: "from-aurora-violet to-aurora-purple",
    text: "text-content",
    skills: [
      "Node.js", "Express.js", "NestJS", "Spring Boot", "FastAPI",
      "Django", "Java", "Python", "Flutter", "REST APIs",
    ],
  },
  {
    title: "Data & Cloud",
    icon: FiCloud,
    accent: "from-aurora-pink to-aurora-rose",
    text: "text-content",
    skills: [
      "PostgreSQL", "MySQL", "MongoDB", "Redis", "AWS",
      "Azure AKS", "GCP", "Docker", "Kubernetes", "CI/CD",
    ],
  },
  {
    title: "Security & IAM",
    icon: FiShield,
    accent: "from-amber-400 to-orange-500",
    text: "text-amber-400",
    skills: [
      "OAuth2", "OIDC", "SAML", "One Identity",
      "SailPoint", "Keycloak", "ForgeRock OpenAM", "RBAC",
    ],
  },
];

const marquee = [
  "React", "Next.js", "Angular", "Vue", "Node.js", "NestJS", "Spring Boot",
  "FastAPI", "Django", "PostgreSQL", "MySQL", "Redis", "Docker", "Kubernetes",
  "AWS", "Azure", "GCP", "TypeScript", "Flutter", "Keycloak", "SailPoint", "OAuth2",
];

const Skills = () => {
  return (
    <section id="skills" className="relative px-6 py-28 md:py-36">
      <div className="container mx-auto max-w-6xl">
        <SectionArt type="toolkit" className="mx-auto mb-4 h-32 w-44" />
        <SectionHeading
          eyebrow="Skills & Stack"
          title="My Toolkit"
          subtitle="A versatile, full-stack toolset I reach for to design, build, and ship polished products end to end."
        />

        <div className="grid gap-6 md:grid-cols-2">
          {groups.map((g, gi) => {
            const Icon = g.icon;
            return (
              <Reveal key={g.title} direction="up" delay={gi * 0.1}>
                <TiltCard className="glass h-full rounded-3xl p-7">
                  <div className="mb-6 flex items-center gap-4">
                    <span
                      className={`flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br ${g.accent} text-xl text-white shadow-glow`}
                    >
                      <Icon />
                    </span>
                    <h3 className="text-2xl font-semibold text-content">
                      {g.title}
                    </h3>
                  </div>
                  <div className="flex flex-wrap gap-2.5">
                    {g.skills.map((s) => (
                      <span
                        key={s}
                        className="cursor-default rounded-full border border-hairline bg-fill px-3.5 py-1.5 text-sm text-muted transition-all duration-300 hover:-translate-y-0.5 hover:border-hairline hover:bg-fill-2 hover:text-content"
                      >
                        {s}
                      </span>
                    ))}
                  </div>
                </TiltCard>
              </Reveal>
            );
          })}
        </div>
      </div>

      {/* infinite tech marquee */}
      <div className="relative mt-16 overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_12%,black_88%,transparent)]">
        <div className="flex w-max animate-marquee gap-4">
          {[...marquee, ...marquee].map((t, i) => (
            <span
              key={i}
              className="whitespace-nowrap rounded-full border border-hairline bg-fill px-5 py-2 text-sm font-medium text-muted"
            >
              {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
